// @flow
import type { AppState } from 'reducer';

export const selectToken = ({ auth }: AppState) => auth.token;

export const selectObservationMap = ({
  appConfig: { observationsMap },
}: AppState) => observationsMap;

export const boundedDelay = (elapsed: number, limit: number = 1000) => {
  return Math.max(Math.abs(Date.now() - elapsed - limit), 0);
};



// WEBPACK FOOTER //
// ./src/ducks/SagaUtils.js